"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findAffiliationDef = void 0;
const error_1 = require("../../error");
const join_1 = require("../nodes/join");
const table_input_1 = require("../nodes/table-input");
const grain_1 = require("./grain");
const filter_1 = require("../nodes/filter");
const grain_suppressor_1 = require("../nodes/grain-suppressor");
const signature_1 = require("../signature");
const query_helper_1 = require("./query-helper");
const filter_types_1 = require("../../common/filter-types");
function findAffiliationDef(dataset1, dataset2, datasetRepo) {
    // Attempt 1: Look for a defined affiliation table
    let dataDef = datasetRepo.datasetByName[dataset1 + ':' + dataset2];
    if (dataDef)
        return dataDef;
    // Attempt 2: Look for an affiliation table whose grain fits the datasets grain
    let grain1 = (0, grain_1.resolveGrain)(datasetRepo.datasetByName[dataset1], datasetRepo);
    let grain2 = (0, grain_1.resolveGrain)(datasetRepo.datasetByName[dataset2], datasetRepo);
    for (let dataDef of datasetRepo.datasets) {
        if (dataDef.tableType !== 'aff')
            continue;
        let affGrain = (0, grain_1.resolveGrain)(dataDef, datasetRepo);
        let ds1Match = !!(0, grain_1.grainSubset)(affGrain, grain1).length;
        let ds2Match = !!(0, grain_1.grainSubset)(affGrain, grain2).length;
        if (ds1Match && ds2Match)
            return dataDef;
    }
    throw new error_1.default(`No affiliations exist between ${dataset1} and ${dataset2}`);
}
exports.findAffiliationDef = findAffiliationDef;
class AffiliationHelper {
    constructor(entity1, entity2, joinType, columns, datasetRepo) {
        this.dataDef = findAffiliationDef(entity1.dataset, entity2.dataset, datasetRepo);
        if (!this.dataDef)
            throw new error_1.default(`No affiliations exist between ${entity1.dataset} and ${entity2.dataset}`);
        this.datasetRepo = datasetRepo;
        // Join entity1 to the affiliation table
        let join1 = new join_1.default(joinType);
        entity1.build().connect(join1, 0);
        let grains = (0, grain_1.resolveGrain)(this.dataDef, datasetRepo);
        for (let grain of grains) {
            if (!columns.includes(grain.name))
                columns.push(grain.name);
        }
        this.affTable = new table_input_1.default(this.dataDef.name, columns)
            .connect(join1, 1);
        // Join the previous join with entity2
        let join2 = new join_1.default(joinType);
        join1.connect(join2, 0);
        entity2.build().connect(join2, 1);
        this.node = join2;
    }
    filterType(type) {
        let column = new signature_1.ColumnSignature('type', this.affTable.id);
        let filterNode = new filter_1.default(column, filter_types_1.TestType.Eq, type);
        this.node.connect(filterNode);
        let grain = new signature_1.GrainSignature(this.dataDef.name, 'type');
        let suppressNode = new grain_suppressor_1.default([grain]);
        filterNode.connect(suppressNode);
        this.node = suppressNode;
        return this;
    }
    build() {
        return this.node;
    }
    buildHelper() {
        let node = this.build();
        return new query_helper_1.default(node, this.datasetRepo);
    }
}
exports.default = AffiliationHelper;
